import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Bill_item_input } from '../models/accounting/bill_item_input';
import { Statement } from '../models/accounting/statement';
import { I_competition_entry } from '../models/i_competition_entry.interface';
import { Entry_type } from '../models/entry_type';

import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class EntryStatementService {

  constructor(private http: HttpClient) { }

  get(entry_id: string): Promise<Statement> {
    return this.getWithRest('entry_id/' + entry_id + '/pending/true');
  }

  private getWithRest(rest_url: string) : Promise<Statement> {
    return new Promise((resolve, reject) => {
      return this.http.get(AppSettings.API_ENDPOINT + 'accounting/entry_statement/' + rest_url).subscribe((response:any) => {

        if(response.type == 'statement' && response.data){
          resolve(response.data);
        } else {
          reject(response);
        }

      },
        error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
    });
  }


    createProposedEntryStatement(entry_type: Entry_type, bill_item_inputs: Bill_item_input[], competition_entries: I_competition_entry[]): Promise<Statement> {

    	let post_data = {
  							data: {
  								type: 'proposed_statement_request',
  								attributes: {
  											entry_type: entry_type,
  											bill_item_inputs: bill_item_inputs,
  											competition_entries: competition_entries
  										}
  								}
  						};

			return new Promise((resolve, reject) => {
	            return this.http.post(AppSettings.API_ENDPOINT + 'accounting/entry_statement/proposed/true',
	                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
	                     if(response.data && response.type=='statement') {
	                       resolve(response.data);
	                       }  else {
	                         reject(response);
	                       }

	                }, error => {
                    if(error instanceof HttpErrorResponse){
                      reject(error.error);
                    } else {
                      reject(error);
                    }
	                });
            });

    }

}
